import { createSlice } from "@reduxjs/toolkit";
import { IStaffConnectSlice } from "../../../models/staff/StaffCommunicationDetails";


const initialStaffConnect: IStaffConnectSlice = {
  staffConnectDetails: undefined,
};

const staffConnectSlice = createSlice({
  name: "staffConnect",
  initialState: initialStaffConnect,
  reducers: {
    setStaffConnectDetail: (state, action: { payload: any }) => {
      state.staffConnectDetails = action.payload;
    },
  },
});

export const { setStaffConnectDetail } = staffConnectSlice.actions;

const staffConnectReducer = staffConnectSlice.reducer;

export type staffConnectState = ReturnType<typeof staffConnectReducer>;

export default staffConnectReducer;
